import React from 'react';
import { withRouter } from 'react-router-dom';
import * as actions from 'Actions';
import { connect } from 'react-redux';
import { parseQuery } from 'HelperFunctions/QueryString';
import { isAllowedRedirectUrl, REDIRECT_URL_NOT_ALLOWED_MESSAGE } from 'HelperFunctions/redirectUrl';
import { Link } from 'react-router-dom';

class AddToCart extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      redirectUrlFailed: false,
    }
  }

  async componentDidMount() {
    const { location, event, setCartProps } = this.props;

    const { itemId, itemType, quantity, redirectUrl } = parseQuery(
      JSON.parse(JSON.stringify(location.search))
    );

    const isValidItemId = /^\d+$/.test(itemId) && parseInt(itemId) > 0;
    const isValidQuantity = /^\d+$/.test(quantity) && parseInt(quantity) >= 0;
    const isValidItemType = ['items', 'addons', 'bundles'].includes(itemType);

    if (!isValidItemId || !isValidItemType || !isValidQuantity) {
      if (await isAllowedRedirectUrl(redirectUrl)) {
        window.location.replace(`${redirectUrl}?failed=true`);
      } else {
        this.setState({ redirectUrlFailed: true });
      }
      return;
    }

    let currentInventoryOnCart = [...event.inventoryOnCart] || [];

    const itemEntryIndex = currentInventoryOnCart.findIndex(
      (cartItem) =>
        cartItem.itemId === parseInt(itemId) && cartItem.itemType === itemType && !cartItem.parentInventory?.id
    );

    if (itemEntryIndex !== -1) {
      currentInventoryOnCart[itemEntryIndex].quantity += parseInt(quantity);
      currentInventoryOnCart[itemEntryIndex].ensureLinkedItemsHaveBeenAdded = true;
    } else {
      currentInventoryOnCart.push({
        itemId: parseInt(itemId),
        itemType,
        quantity: parseInt(quantity),
        ensureLinkedItemsHaveBeenAdded: true,
      });
    }

    setCartProps({ inventoryOnCart: currentInventoryOnCart });

    if (await isAllowedRedirectUrl(redirectUrl)) {
      window.location.replace(redirectUrl);
    } else {
      this.setState({ redirectUrlFailed: true });
    }
  }

  render() {
    return <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100vw', flexDirection: 'column'}}>
      {
        this.state.redirectUrlFailed ? 
          <>
            <p>{REDIRECT_URL_NOT_ALLOWED_MESSAGE}</p>
            <br/>
            <Link className='btn' to='/'>
              Back to Home
            </Link>
          </> : <>
            Adding items to cart...
          </>
      }
    </div>
  }
}
const mapStateToProps = (state, ownProps) => {
  const { event } = state.cart;

  return { event };
};

export default withRouter(connect(mapStateToProps, actions)(AddToCart));
